import React, { useEffect, useState, useRef } from "react";
import HttpService from "../services/httpService";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import ASMDashboard from './AsmDashboardTable';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    withStyles,
    Typography,
    TableContainer,
    Accordion, AccordionSummary, AccordionDetails,CircularProgress,
} from "@material-ui/core";
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME, salesDepartment } from "../utils/index";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { setSalesStageLead, leadToMeetingOrderData, clearSalesStageLead, clearL2Mdata } from '../redux/actions/leadSourceActions';
import { setUserDetails } from '../redux/actions/userAction';
import { commaSeparateAmount } from '../components/commaSeparate';
import TableFooter from '@material-ui/core/TableFooter';


const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: "1px solid #eee5e5",
        background: "blue",
    },
    table: {
        minWidth: 700,
    },
    root: {
        width: "100%",
    },
    customTableContainer: {
        overflowX: "initial",
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: "#FDB913",
        color: "#151921",
        padding: "1",
        marginRight: "0.5em",
        borderRadius: "20px",
        width: "20%",
        "&:hover": { backgroundColor: "#14419c", color: "white" },
    },
    heading: {
        fontWeight: '600',
        fontSize: '17px',
        textAlign: 'center'
    },
    leadClearButton: {
        backgroundColor: "#f7b7b7", // light red background
        color: "#151921",
        padding: "1",
        marginRight: "0.5em",
        borderRadius: "20px",
        width: "20%",
    },
    submitButton: {
        backgroundColor: "#F47E46 !important", // Decorpot Orange
        color: "white",
        "&:hover": { backgroundColor: "#E0663D !important" }, // Darker Orange on hover
    },
    tableViewButton: {
        backgroundColor: '#1C375D',
        color: '#FFF2EB',
        padding: '2',
        marginRight: '0.5em',
        borderRadius: '20px',
        "&:hover": { backgroundColor: "#1C375D", color: '#FFF2EB' }
    },
    boardViewButton: {
        backgroundColor: '#1C375D',
        color: '#FFF2EB',
        padding: '2',
        marginRight: '0.5em',
        borderRadius: '20px',
        "&:hover": { backgroundColor: "#1C375D", color: '#FFF2EB' }
    },
    title: {
        marginBottom: theme.spacing(2),
        fontWeight: "bold",
        fontSize: "1.2rem",
        textAlign: "center",
    },
    cellStyle: {
        padding: 10,
        width: 500,
        textAlign: "center",
        fontWeight: 700,
        backgroundColor: "#1C375D",
        color: "white",
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: "#FFF2EB",
        fontWeight: "500",
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const LeadFromMeetingToOrder = (props) => {
    const salesL2MData = useSelector((state) => state.leadSource.salesL2MData);
    const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const classes = useStyles();
    const { userDetails } = useSelector((state) => state.user);
    const [commonLocation, setLocation] = useState([]);
    const [commonExpCenter, setExpCenter] = useState([]);
    const [storeDateFilter, setPivotDatefilters] = useState({
        startDate: "",
        endDate: "",
    });
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([]);
    const [selectedRole, setSelectedRole] = useState('ALL');
    const [usersData, setUsersData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [teamUsers, setTeamUsers] = useState([]); //asm
    const [leadData, setLeadData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [clickData, setClickData] = useState([]);
    const [boardViewData, setBoardViewData] = useState([])
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const DISABLE_UNTIL_KEY = 'fetchButton_disableUntil';
    const [isDisabled, setIsDisabled] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);
    const dispatch = useDispatch()
    const [startDate, setStartDate] = useState(userDetails.selectedStartDate ? userDetails.selectedStartDate : moment().subtract(1, 'months').format('YYYY-MM-DD'))
    const [endDate, setEndDate] = useState(userDetails.selectedEndDate ? userDetails.selectedEndDate : moment().add(1, 'days').format('YYYY-MM-DD'));
    const [selectedFilterOption, setSelectedFilterOption] = useState(userDetails.selectedFilterOption ? userDetails.selectedFilterOption : 'createdAt');
    const [defaultExpCenterId, setDefaultExpCenterId] = useState(userDetails.selectedExpCenter);
    const salesDetails = useSelector((state) => state.leadSource.salesStageLead);
    const [designData, setDesignData] = useState([]);
    const [projectViewType, setProjectViewType] = useState();
    const [marketingData, setMarketingData] = useState([]);
    const [salesData, setSalesData] = useState([]);
    const [submitButtonClick, setSubmitButtonClick] = useState(false);
    const [monthlyData, setMonthlyData] = useState([]);
    const [handleSubmitData, setHandleSubmitData] = useState(false)
    const [dates, setDates] = useState({
        start: startDate,
        end: endDate
    });
    const [wonLeadView, setWonLeadView] = useState('');
    const [performanceData, setPerformanceData] = useState([]);
    const [dataBasedOnClickAcv, setDataBasedOnClickAcv] = useState([]);
    const [dataBasedOnClickAcvModal, setDataBasedOnClickAcvModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const getMonthYearLabel = (monthsAgo) => {
        const date = new Date(); // Always start from now
        const newDate = new Date(date.getFullYear(), date.getMonth() - monthsAgo, 1); // Create a new adjusted date
        return newDate.toLocaleString("default", { month: "short", year: "2-digit" }); // e.g., "Feb-25"
    };

    const getPerformanceColor = (percentage) => {
        if (percentage === undefined || percentage === null) return "gray"; // Default color
        if (percentage >= 100) return "darkgreen";
        if (percentage >= 80) return "yellow";
        if (percentage < 80) return 'red';
    };

    function formatRupees(amount) {
        const amountInLacs = amount / 100000;
        return new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: 2,
        }).format(amountInLacs);
    }

    useEffect(() => {
        locations();
        if (userDetails?.roles?.find(role => role.name === ROLENAME.SalesUser)) {
            performanceTarget();
        }
        if (userDetails?.roles?.find(role => role.name === ROLENAME.AssistantSalesManager)) {
            getTeamUsers();
        }
        expCenters();
        getLeadData();
        monthlyConversionData();
    }, []);

    useEffect(() => {
        // Check if there's a stored disable time in localStorage
        const disableUntilTimestamp = localStorage.getItem(DISABLE_UNTIL_KEY);

        if (disableUntilTimestamp) {
            const now = new Date().getTime();
            const disableUntil = parseInt(disableUntilTimestamp, 10);

            // If the disable time is in the future, calculate remaining time
            if (disableUntil > now) {
                const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
                setTimeLeft(remainingTimeInSeconds);
                setIsDisabled(true);
            } else {
                // If the time has passed, clear localStorage
                localStorage.removeItem(DISABLE_UNTIL_KEY);
                setIsDisabled(false);
                setTimeLeft(0);
            }
        }

        // Set up timer to update remaining time
        let timer;
        if (isDisabled && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft(prevTime => {
                    const newTime = prevTime - 1;
                    if (newTime <= 0) {
                        // When time is up, clear localStorage and enable button
                        localStorage.removeItem(DISABLE_UNTIL_KEY);
                        setIsDisabled(false);
                        return 0;
                    }
                    return newTime;
                });
            }, 1000);
        }

        return () => clearInterval(timer);
    }, [isDisabled, timeLeft]);


    // Location data
    const locations = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getLocation();
            const matchedUsers = response.data.filter((user) => {
                return userDetails.selectedLocation.includes(user._id);
            });
            setLocation(matchedUsers);
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(
                error?.response?.data ?? "Something Went Wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    // experience data
    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter((user) => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers);
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(
                error?.response?.data ?? "Something Went Wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    // date Filter
    const storePivotDate = (e) => {
        const { name, value } = e.target;
        setPivotDatefilters({ ...storeDateFilter, [name]: value });
    };

    //  Location filter
    const handleMultipleLocationData = (e, newValue) => {
        let arrLocationObj = [];
        arrLocationObj.push(newValue);
        setSelectedLocation(arrLocationObj);
    };

    // exp filter
    const handleMultipleExpData = (e, newvalue) => {
        let arrExpObj = [];
        arrExpObj.push(newvalue);
        setSubmitButtonClick(false);
        setSelectedExperienceCenter(arrExpObj);
    };

    const handleMultipleUsers = (e, newvalue) => {
        setSelectedUsers(newvalue)
    }

    const getSalesData = async (expCenters) => {
        const ids = expCenters?.map((item) => item._id);

        if (
            userDetails.roles.find(
                (role) =>
                    role?.name === ROLENAME.SalesHead ||
                    role?.name === ROLENAME.DGM_Sales
            ) &&
            ids.length === 0
        ) {
            props.setSnackInfo("Please Select the Experience Center.", "info");
            return; // Exit function early if no EC is selected
        } else {
            props.setSnackInfo("Data Loading, please wait...", "info");
        }

        // Show loading spinner
        props.setLoading(true);

        let data = {
            startDate: startDate,
            endDate: endDate,
            experienceCenterId: userDetails.roles.find(
                (role) =>
                    role?.name === ROLENAME.SalesHead ||
                    role?.name === ROLENAME.DGM_Sales
            )
                ? ids.length !== 0
                    ? ids
                    : []
                : ids.length !== 0
                    ? ids
                    : defaultExpCenterId,
            filterOption: selectedFilterOption,
        };

        try {
            // Make the API request
            if (salesDetails && salesDetails.length > 0) {
                setSalesData(salesDetails);
            } else {
                let response = await HttpService.getSalesLeadOnSelectedDate(data);

                if (response.status === 200) {
                    dispatch(setSalesStageLead(response.data));
                    setSalesData(response.data);
                    props.setSnackInfo("Data Loaded Successfully", "success");
                }
            }
        } catch (error) {
            console.error(error, "error");
            props.setSnackInfo("Error Loading Data", "error");
        } finally {
            props.setLoading(false);
        }
    };

    // handle role
    const handleSelectRoles = async (event, role) => {
        setSelectedUsers([])
        let obj = {}
        if (role) {
            obj.role = role
        } else {
            setSelectedRole(event.target.value)
            obj.role = event.target.value
        }
        try {
            let response = await HttpService.getSelectedUsersBasedOnRoles(obj);
            const activeUsers = response.data.filter(user => user.isActive).sort((a, b) => a.name.localeCompare(b.name));
            activeUsers.push({ name: '─ Inactive User ─', inActiveStart: true })
            const inactiveUsers = response.data.filter(user => !user.isActive).sort((a, b) => a.name.localeCompare(b.name));
            let userArray = [...activeUsers, ...inactiveUsers]
            setUsersData(userArray);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
    }
    // get team user data
    const getTeamUsers = async () => {
        props.setLoading(true)
        try {
            const response = await HttpService.getTeamUsersList(userDetails.teamId._id)
            let sortedResponse = response.data.sort((a, b) => a.name.localeCompare(b.name))
            setTeamUsers(sortedResponse);
        } catch (error) {
            console.error(error)
        }
        props.setLoading(false)
    }


    const getMarketingData = async () => {
        try {
            props.setLoading(true);
            let data = {
                startDate: startDate,
                endDate: endDate,
                experienceCenterId: defaultExpCenterId,
            };
            const response = await HttpService.getLeadsOnSelectedDate(data);
            setMarketingData(response?.data);
            props.setLoading(false);
        }
        catch (error) {
            console.error(error);
        }
    };

    // handle submit button
    const handleSubmit = async () => {
        try {
            props.setLoading(true);
            await getLeadData();
            // setHandleSubmitData(true);
            await monthlyConversionData();
            dispatch(clearL2Mdata());
            setSubmitButtonClick(true);
            // const locationData = selectedLocation?.map((el) => el?._id); 
            // let expCenterData = selectedExperienceCenter?.map((el) => el?._id)
            // const startDate = new Date(storeDateFilter.startDate); 
            // const endDate = new Date(storeDateFilter.endDate);
            // const monthsBetween = getMonthsBetweenDates(startDate, endDate);
            // if(storeDateFilter.startDate !== "" && storeDateFilter.endDate !== ""){
            //     setStaticTableData(monthsBetween);
            // }
            // else if( storeDateFilter.startDate === "" && storeDateFilter.endDate === "" || (locationData.length > 0 || expCenterData.length > 0) ){
            //     getStaticTableData();
            // } 
        }
        catch (err) {
            console.error(err);
        }
    }

    const getDesignData = async () => {
        let obj = {
            startDate,
            endDate,
            expcenterId: userDetails.selectedExpCenter
        };

        props.setLoading(true);

        try {
            const response = await HttpService.getDesignData(obj);
            setDesignData(response.data);
        } catch (error) {
            console.log(error);
            props.snackInfo?.("Failed to fetch design data. Please try again.", "error");
        } finally {
            props.setLoading(false);
        }
    };

    const getLeadsOnSelectedDateByRole = () => {
        setDates({
            start: startDate,
            end: endDate,
        });
        props.setUserDetails({
            ...userDetails,
            selectedStartDate: startDate,
            selectedEndDate: endDate,
            selectedFilterOption: selectedFilterOption,
        });
        if (
            userDetails?.roles?.find(
                (role) =>
                    role?.name === ROLENAME.DesignHead ||
                    role?.name === ROLENAME.AGM_Design ||
                    role?.name === ROLENAME.DesignManager ||
                    role?.name === ROLENAME.OperationDesignManager ||
                    role?.name === ROLENAME.DesignUser
            )
        ) {
            getDesignData();
        }
        if (
            userDetails?.roles?.find(
                (role) =>
                    role?.name === ROLENAME.MarketingManager ||
                    role.name === ROLENAME.MarketingUser
            )
        ) {
            getMarketingData();
        }
        if (
            userDetails?.roles?.find(
                (role) =>
                    role?.name === ROLENAME.SalesHead ||
                    role?.name === ROLENAME.DGM_Sales ||
                    role?.name === ROLENAME.AGMSales ||
                    role?.name === ROLENAME.SalesManager ||
                    role?.name === ROLENAME.SalesUser ||
                    role?.name === ROLENAME.AssistantSalesManager
            )
        ) {
            getSalesData(selectedExperienceCenter);
            getLeadData();
        }
    };

    //handle by default data
    const getLeadData = async () => {
        const locationData = selectedLocation?.flat().map(el => el._id) || [];
        const expCenterData = selectedExperienceCenter?.flat().map(el => el._id) || [];
        let users = "";
        let teamUser = "";
        if (
            (usersData?.users && usersData?.users.length !== 0) ||
            (selectedUsers && selectedUsers.length !== 0)
        ) {
            users =
                usersData?.users?.map((el) => el._id) ||
                selectedUsers?.map((el) => el._id);
            teamUser = selectedUsers?.map((el) => el.teamId);
        }
        // user detail location and experience center
        let userLocation = userDetails?.locationId?.map((el) => el?._id);
        let userExpCenter = userDetails?.experienceCenterId;

        props.setLoading(true);

        try {
            let res; // Declare once at the top
            let obj = {
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                selectedLocation:
                    locationData.length !== 0 ? locationData : userLocation,
                selectedExpCenter:
                    expCenterData.length !== 0 ? expCenterData : userExpCenter,
                selectedRole: selectedRole,
                selectedUser: users,
                userWithTeamId: teamUser,
            };

            // if (handleSubmitData) {
            res = await HttpService.getLeadToMeetingOrderData(obj);
            // } else {
            // If Redux store has no data, make API call
            //   if (!salesL2MData || salesL2MData.length === 0) {
            //     const apiRes = await HttpService.getLeadToMeetingOrderData(obj);

            //     if (apiRes.status === 200) {
            //       dispatch(leadToMeetingOrderData(apiRes.data));
            //       res = apiRes;
            //     } else {
            //       res = { data: [] }; // fallback
            //     }
            //   } else {
            //     // Use Redux data
            //     res = { data: salesL2MData };
            //   }
            // }

            let monthlyData =
                res?.data?.[res?.data?.length - 1]?.monthlyGrandTotal || [];

            if (
                storeDateFilter.startDate !== "" &&
                storeDateFilter.endDate !== ""
            ) {
                const startDate = new Date(storeDateFilter.startDate);
                const endDate = new Date(storeDateFilter.endDate);

                const current = new Date(
                    startDate.getFullYear(),
                    startDate.getMonth(),
                    1
                );
                const last = new Date(endDate.getFullYear(), endDate.getMonth(), 1);

                const targetMonths = [];

                while (current <= last) {
                    targetMonths.push({
                        monthName: monthNames[current.getMonth()],
                        monthNumber: current.getMonth() + 1,
                        year: current.getFullYear(),
                    });

                    current.setMonth(current.getMonth() + 1);
                }

                targetMonths.forEach((month) => {
                    const exists = monthlyData.some(
                        (data) =>
                            data.monthNumber === month.monthNumber &&
                            data.year === month.year
                    );

                    if (!exists) {
                        monthlyData.push({
                            monthName: month.monthName,
                            monthNumber: month.monthNumber,
                            year: month.year,
                            count: 0,
                            leadInMarketing: 0,
                            leadToMeetingCount: 0,
                            leadToOrderCount: 0,
                            meetingToOrderCount: 0,
                        });
                    }
                });

                monthlyData.sort((a, b) => {
                    if (a.year !== b.year) {
                        return a.year - b.year;
                    } else {
                        return a.monthNumber - b.monthNumber;
                    }
                });
            } else if (
                storeDateFilter.startDate === "" &&
                storeDateFilter.endDate === ""
            ) {

                const today = new Date();
                const targetMonths = [];

                // Get current month + last 3 months
                for (let i = 0; i < 4; i++) {
                    const date = new Date(today.getFullYear(), today.getMonth() - i, 1);
                    targetMonths.push({
                        monthName: monthNames[date.getMonth()],
                        monthNumber: date.getMonth() + 1,
                        year: date.getFullYear(),
                    });
                }

                // Push missing months with default data
                targetMonths.forEach((month) => {
                    const exists = monthlyData.some(
                        (data) =>
                            data.monthName === month.monthName && data.year === month.year
                    );

                    if (!exists) {
                        monthlyData.push({
                            monthName: month.monthName,
                            monthNumber: month.monthNumber,
                            year: month.year,
                            count: 0,
                            leadInMarketing: 0,
                            leadToMeetingCount: 0,
                            leadToOrderCount: 0,
                            meetingToOrderCount: 0,
                        });
                    }
                });

                // Sort by year and then by monthNumber
                monthlyData.sort((a, b) => {
                    if (a.year !== b.year) {
                        return a.year - b.year;
                    } else {
                        return a.monthNumber - b.monthNumber;
                    }
                });
            }

            // Ensure the modified monthlyData is set back into res
            if (res?.data?.length) {
                res.data[res.data.length - 1].monthlyGrandTotal = monthlyData;
            }

            setLeadData(res.data);
        } catch (err) {
            console.error(err);
        }
        props.setLoading(false);
    };

    // handle monthlyConversion Goal Data
    const monthlyConversionData = async () => {
        try {
            props.setLoading(true);
            let obj = {
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
            };
            let res = await HttpService.getMonthlyConversionGoalsDataOnL2M(obj);
            const isSalesRole = userDetails?.roles?.some(
                (item) =>
                    item?.name === ROLENAME.AssistantSalesManager ||
                    item?.name === ROLENAME.SalesUser
            );

            let filterData;
            
            if (isSalesRole) {
                filterData = res?.data?.find((item) =>
                    userDetails.selectedExpCenter.includes(item.experienceCenterId)
                );
            } else {
                if (selectedExperienceCenter && selectedExperienceCenter.length > 0) {
                    // Get the first selected center's name 
                    const firstCenter = selectedExperienceCenter[0];
                    let centerName = firstCenter.name || firstCenter.centerName || 
                                    firstCenter.experienceCenterName || firstCenter.location;
                    
                    if (!centerName && typeof firstCenter === 'string') {
                        centerName = firstCenter;
                    }
                    
                    if (centerName) {
                        filterData = res?.data?.find((item) =>
                            item.experienceCenterName === centerName
                        );
                    } else {
                        // Fallback to first data if we can't find the name
                        filterData = res?.data?.[0];
                    }
                } else {
                    filterData = res?.data?.[0];
                }
            }
            setMonthlyData(filterData?.data);
            props.setLoading(false);
        } catch (err) {
            console.error(err);
        }
    };
        // Download function
        const DownLoadExcelConversionData = async () => {
            setLoading(true);
            try {
                const obj = {
                    startDate: storeDateFilter.startDate,
                    endDate: storeDateFilter.endDate,
                };

                const response = await HttpService.DownLoadExcelConversionData(obj);

                // Create blob URL
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });

                const url = window.URL.createObjectURL(blob);

                // Create hidden link
                const link = document.createElement('a');
                link.href = url;
                link.download = `leads_${new Date().toISOString().split('T')[0]}.xlsx`;

                document.body.appendChild(link);
                link.click();

                // Cleanup
                link.remove();
                window.URL.revokeObjectURL(url);

            } catch (error) {
                console.error('Download failed:', error);
                alert('Failed to download Excel file');
            } finally {
                setLoading(false);
            }
        };
    

    const dataBasedOnClick = async (data, particularName) => {
        props.setLoading(true);
        try {
            setClickData(data);
            setOpenModal(true);

            // Group data based on current stage because of board view
            const grouped = {};
            for (const item of data) {
                if (!grouped[item.currentStage]) {
                    grouped[item.currentStage] = [];
                }
                grouped[item.currentStage].push(item);
            }

            const project = Object.entries(grouped).map(([stage, items]) => {
                const finalAmount = items.reduce((acc, cur) => acc + (cur.grandTotal || 0), 0);
                return {
                    currentStage: stage,
                    finalAmount: finalAmount,
                    projects: items
                };
            });

            setBoardViewData(project);

            let val = localStorage.getItem('View')
            if (val !== null) {
                setProjectViewType('table')
            } else {
                setProjectViewType('board');
            }
            setWonLeadView('');
        }
        catch (err) {
            console.error(err);
        }
        props.setLoading(false);
    }

    const changeView = (data) => {
        setProjectViewType('table');
        setWonLeadView(data);
    }

    const performanceTarget = async () => {
        props.setLoading(true);
        let obj = {
            pivotValue: "performanceTargetSEDashboard",
            userExpCenter: userDetails.experienceCenterId,
            isExpanded: true,
        };
        try {
            let response = await HttpService.performanceVisiabilityForAdmin('', obj.userExpCenter, false, obj.pivotValue);
            setPerformanceData(response?.data[0]?.data);
        } catch (error) {
            props.setSnackInfo(
                error?.response?.data ?? "Something Went Wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    const dataBasedOnClickAcvAmount = async (year, month) => {
        try {
            let obj = {
                year: year,
                month: month
            }
            const res = await HttpService.getDataBasedOnClickAcvAmount(obj);
            setDataBasedOnClickAcv(res?.data);
            setDataBasedOnClickAcvModal(true);
        } catch (error) {
            console.error("error", error);
        }
    };

    // Download CSV Part
    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "assignName", label: "Assign To" },
        { key: "cityName", label: "City Name" },
        { key: "expCtrName", label: "Exp. Ctr Name" },
        { key: "currentStage", label: "Current Stage" },
        { key: "leadCreatedDate", label: "Lead Created Date" },
        { key: "salesExecutive", label: "Sales Executive" },
        { key: "asm", label: "ASM" },
    ];

    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < clickData.length; i++) {
                let obj = {
                    serialNo: i + 1,
                    projectCode: clickData[i]?.erpProjectNo || "N/A",
                    leadNumber: clickData[i]?.lead_no || "N/A",
                    clientName: clickData[i]?.customerName,
                    assignName: clickData[i]?.assignToName,
                    cityName: clickData[i]?.cityName,
                    expCtrName: clickData[i]?.experienceCenterName,
                    currentStage: clickData[i]?.currentStage ? clickData[i]?.currentStage : 'NA',
                    leadCreatedDate: moment(clickData[i]?.createdAt).format('DD-MM-YYYY') || "NA",
                    salesExecutive: clickData[i]?.salesUserName || "NA",
                    asm: clickData[i]?.assistantSalesManagerName || "NA",
                };
                csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };

    const handleRefreshClick = () => {
        // Calculate the timestamp 4 minutes from now
        const disableUntilTimestamp = new Date().getTime() + 4 * 60 * 1000;
        // Store the timestamp in localStorage
        localStorage.setItem(DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());
        // Disable the button for 4 minutes
        setIsDisabled(true);
        setTimeLeft(240); // 4 minutes in seconds
        // Perform the data fetching operations
        dispatch(clearSalesStageLead());
        dispatch(clearL2Mdata());
        getLeadsOnSelectedDateByRole();
    };

    // Helper function to format the time
    const formatTimeLeft = () => {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    };

    // handling to show data table
    const userRoles = userDetails?.roles?.map(role => role?.name);
    // Check for privileged roles
    const isPrivilegedRole = userRoles?.some(role =>
        [ROLENAME.DGM_Sales, ROLENAME.Admin, ROLENAME.BusinessHead, ROLENAME.SalesManager, ROLENAME.SalesHead, ROLENAME.AGMSales, ROLENAME.CenterHead].includes(role)
    );
    // Check for direct roles
    const isDirectShowRole = userRoles?.some(role =>
        [ROLENAME.SalesUser, ROLENAME.AssistantSalesManager].includes(role)
    );

    // Table and Board View
    const projectTableView = (value) => {
        localStorage.setItem('View', value);
        setProjectViewType(value);
    }

    const projectBoardView = (value) => {
        localStorage.setItem('View', value);
        setProjectViewType(value);
    }

    return (
        <div className="App">
            <br />

            {userDetails.roles.find(role => role.name === 'Sales User') &&
                <paper>
                    {/* 1. performance Vs Target */}
                    <Accordion expanded={true}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className={classes.heading}>
                                Performance Vs target
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ padding: 0 }}>
                            <TableContainer component={Paper}>
                                <Table
                                    className={classes.table}
                                    stickyHeader
                                    aria-label="sticky table"
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.cellStyle}></TableCell>
                                            <TableCell className={classes.cellStyle}>
                                                {performanceData[2] &&
                                                    `${monthNames[performanceData[2].month - 1]} - ${performanceData[2].year
                                                    }`}
                                            </TableCell>
                                            <TableCell className={classes.cellStyle}>
                                                {performanceData[1] &&
                                                    `${monthNames[performanceData[1].month - 1]} - ${performanceData[1].year
                                                    }`}
                                            </TableCell>
                                            <TableCell className={classes.cellStyle}>
                                                {performanceData[0] &&
                                                    `${monthNames[performanceData[0].month - 1]} - ${performanceData[0].year
                                                    }`}
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    {/* Performance vs acv target have to table body data */}
                                    <TableBody>
                                        <TableRow>
                                            <TableCell className={classes.cellStyle}>
                                                Target
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                style={{ padding: 10, textAlign: "center" }}
                                            >
                                                {formatRupees(performanceData[2]?.target)}
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                style={{ padding: 10, textAlign: "center" }}
                                            >
                                                {formatRupees(performanceData[1]?.target)}
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                style={{ padding: 10, textAlign: "center" }}
                                            >
                                                {formatRupees(performanceData[0]?.target)}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.cellStyle}>
                                                Achieved(amount)
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                style={{ padding: 10, textAlign: "center", textDecoration: "underline", cursor: 'pointer' }}
                                                onClick={() => dataBasedOnClickAcvAmount(performanceData[2].year, performanceData[2].month)}
                                            >
                                                {formatRupees(performanceData[2]?.achieved)}
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                style={{ padding: 10, textAlign: "center", textDecoration: "underline", cursor: 'pointer' }}
                                                onClick={() => dataBasedOnClickAcvAmount(performanceData[1].year, performanceData[1].month)}
                                            >
                                                {formatRupees(performanceData[1]?.achieved)}
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                style={{ padding: 10, textAlign: "center", textDecoration: "underline", cursor: 'pointer' }}
                                                onClick={() => dataBasedOnClickAcvAmount(performanceData[0].year, performanceData[0].month)}
                                            >
                                                {formatRupees(performanceData[0]?.achieved)}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell className={classes.cellStyle}>
                                                Achieved(%)
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                style={{
                                                    padding: 10,
                                                    textAlign: "center",
                                                    backgroundColor: getPerformanceColor(
                                                        performanceData[2]?.performancePercentage
                                                    ),
                                                }}
                                            >
                                                {performanceData[2]?.performancePercentage}
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                style={{
                                                    padding: 10,
                                                    textAlign: "center",
                                                    backgroundColor: getPerformanceColor(
                                                        performanceData[1]?.performancePercentage
                                                    ),
                                                }}
                                            >
                                                {performanceData[1]?.performancePercentage}
                                            </TableCell>
                                            <TableCell
                                                component="th"
                                                style={{
                                                    padding: 10,
                                                    textAlign: "center",
                                                    backgroundColor: getPerformanceColor(
                                                        performanceData[0]?.performancePercentage
                                                    ),
                                                }}
                                            >
                                                {performanceData[0]?.performancePercentage}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </AccordionDetails>
                    </Accordion>
                </paper>
            }
            <br />
            <br />
            <div className={classes.header}>
                <Typography variant="h4" className={classes.title}>
                    Monthly Conversion % Goals: Previous Months and Current
                </Typography>
            </div>
            <div>
                {/* Ribbon Component */}
                <Paper className={classes.paper}>
                    <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        justifyContent="center"
                    >
                        {/* Lead Created Start Date */}
                        <Grid item xs={12} sm={3}>
                            <TextField
                                id="startDate"
                                name="startDate"
                                label="Lead Assigned At From Date"
                                type="date"
                                variant="outlined"
                                value={storeDateFilter.startDate}
                                onChange={storePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    max: new Date().toISOString().split("T")[0]
                                }}
                                fullWidth
                            />
                        </Grid>
                        {/* Lead created End Date */}
                        <Grid item xs={12} sm={3}>
                            <TextField
                                id="endDate"
                                name="endDate"
                                label="Lead Assigned At End Date"
                                type="date"
                                variant="outlined"
                                value={storeDateFilter.endDate}
                                onChange={storePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    max: new Date().toISOString().split("T")[0]
                                }}
                                fullWidth
                            />
                        </Grid>

                        {/* Location Center */}
                        {userDetails?.roles &&
                            userDetails?.roles?.some((role) =>
                                [
                                    ROLENAME.CenterHead,
                                    ROLENAME.BusinessHead,
                                    ROLENAME.Admin,
                                    ROLENAME.SalesHead,
                                    ROLENAME.SalesManager,
                                    ROLENAME.AGM_Sales,
                                    ROLENAME.DGM_Sales,
                                    ROLENAME.AGM_Sales,
                                ].includes(role.name)
                            ) && (
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: "100%" }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedLocation[0]?.locationId?.name}
                                            onChange={handleMultipleLocationData}
                                            options={commonLocation}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Location"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            )}
                        {/* Experience Center */}
                        {userDetails?.roles &&
                            userDetails?.roles?.some((role) =>
                                [
                                    ROLENAME.CenterHead,
                                    ROLENAME.BusinessHead,
                                    ROLENAME.Admin,
                                    ROLENAME.SalesHead,
                                    ROLENAME.SalesManager,
                                    ROLENAME.DGM_Sales,
                                    ROLENAME.AGM_Sales,
                                ].includes(role.name)
                            ) && (
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: "100%", marginTop: "0.4rem" }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedLocation[0]?.name}
                                            onChange={handleMultipleExpData}
                                            options={commonExpCenter}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Exp-Center"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            )}

                        {/* Select Role and User */}

                        {(userDetails?.roles && userDetails?.roles?.some(role => [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.Admin].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        >
                                            <MenuItem value={"ALL"}>ALL</MenuItem>
                                            <MenuItem value={ROLENAME.DGM_Sales}>DGM</MenuItem>
                                            <MenuItem value={ROLENAME.AGMSales}>AGM</MenuItem>
                                            <MenuItem value={ROLENAME.SalesManager}>Manager</MenuItem>
                                            <MenuItem value={ROLENAME.AssistantSalesManager}>Assistant Sales Manager</MenuItem>
                                            <MenuItem value={ROLENAME.SalesUser}>Executive</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>

                            </>
                        )}

                        {(userDetails?.roles && userDetails?.roles?.some(role => [ROLENAME.SalesManager].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        >
                                            <MenuItem value={"ALL"}>ALL</MenuItem>
                                            <MenuItem value={ROLENAME.AssistantSalesManager}>Assistant Sales Manager</MenuItem>
                                            <MenuItem value={ROLENAME.SalesUser}>Executive</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>

                            </>
                        )}

                        {(userDetails?.roles && userDetails?.roles?.some(role => [ROLENAME.SalesHead, ROLENAME.DGM_Sales, ROLENAME.AGMSales].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '90%', marginTop: "0.4rem" }}>
                                        <TextField
                                            select
                                            labelId="project-doc"
                                            label="Select Role"
                                            variant="outlined"
                                            value={selectedRole}
                                            onChange={(e) => handleSelectRoles(e)}
                                        >
                                            <MenuItem value={"ALL"}>ALL</MenuItem>
                                            <MenuItem value={ROLENAME.SalesManager}>Manager</MenuItem>
                                            <MenuItem value={ROLENAME.AssistantSalesManager}>Assistant Sales Manager</MenuItem>
                                            <MenuItem value={ROLENAME.SalesUser}>Executive</MenuItem>
                                        </TextField>
                                    </FormControl>
                                </Grid>

                            </>
                        )}


                        {(userDetails?.roles && userDetails?.roles?.some(role => [ROLENAME.CenterHead, ROLENAME.BusinessHead, ROLENAME.Admin, ROLENAME.SalesHead, ROLENAME.DGM_Sales, ROLENAME.AGMSales, ROLENAME.SalesManager, ROLENAME.AssistantSalesManager].includes(role.name))) && (
                            <>
                                <Grid item xs={12} sm={3}>
                                    <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                                        <Autocomplete
                                            multiple
                                            value={selectedUsers}
                                            onChange={(e, v) => handleMultipleUsers(e, v)}
                                            options={
                                                userDetails?.roles?.find(role => role?.name === ROLENAME.AssistantSalesManager)
                                                    ? teamUsers
                                                    : usersData
                                            }
                                            getOptionLabel={(option) => option.name}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            renderOption={(options) => (
                                                <li {...options}>
                                                    <span style={{ color: options.inActiveStart ? 'red' : options.isActive ? 'black' : 'grey', }}>
                                                        {options.name}
                                                    </span>
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Users"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid>
                            </>
                        )}

                        {/* Sales User Selection */}
                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSubmit}
                                style={{
                                    backgroundColor: "#F50057",
                                    color: "#fff",
                                    padding: "0.4rem 2rem 2rem 2rem",
                                }}
                                className={classes.submitButton}
                            >
                                Submit
                            </Button>

                            <Button
                                onClick={handleRefreshClick}
                                variant="contained"
                                disabled={isDisabled}
                                style={{
                                    backgroundColor: isDisabled ? "#cccccc" : "#F47E46",
                                    color: "#FFF2EB",
                                    padding: "8px 16px"
                                }}
                            >
                                {isDisabled
                                    ? `Wait (${formatTimeLeft()})`
                                    : "Fetch New Data"
                                }
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                onClick={DownLoadExcelConversionData}
                                disabled={loading}
                                style={{ 
                                    backgroundColor: loading ? "#cccccc" : "#355025", 
                                    color: "#FFF2EB" 
                                }}
                                color="secondary"
                                startIcon={loading && <CircularProgress size={20} color="inherit" />}
                            >
                                {loading ? 'Downloading...' : 'Download CSV'}
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </div>
            <br />

            {/* Table component */}
            {
                // (
                //     commonExpCenter.length <= 1 || 
                //     (Array.isArray(selectedExperienceCenter) && 
                //     selectedExperienceCenter?.filter(Boolean)?.length === 1 && 
                //     submitButtonClick)
                //     )
                ((isPrivilegedRole && submitButtonClick && selectedExperienceCenter?.length !== 0) || isDirectShowRole) ?
                    <div>
                        <>
                            <Grid
                                container
                                spacing={5}
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Grid item xs={5}>
                                    <>
                                        <Button
                                            style={{
                                                backgroundColor: "#1C375D",
                                                color: "#FFF2EB",
                                                marginBottom: "5px",
                                                fontWeight: 600
                                            }}
                                        >
                                            Table - 1
                                        </Button>
                                        <h3> Monthly Conversion % Goals: Previous Months and Current</h3>
                                    </>
                                </Grid>
                            </Grid>
                            <div style={{ maxHeight: "500px", overflow: "auto" }}>
                                <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '10px' }}>
                                    <Table size="small" style={{ minWidth: '600px' }}> {/* Ensure a minimum width for horizontal scrolling */}
                                        <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                                            <StyledTableRow>
                                                <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}></StyledTableCell>
                                                {monthlyData?.map((item, monthIndex) => (
                                                    <React.Fragment key={monthIndex}>
                                                        <StyledTableCell
                                                            style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 'bold' }}
                                                        >
                                                            {`${item?.month}- ${item?.year?.toString()?.slice(-2)}`}
                                                        </StyledTableCell>
                                                    </React.Fragment>
                                                ))}
                                            </StyledTableRow>
                                        </TableHead>

                                        <TableBody style={{ position: 'sticky', top: 0, background: 'white' }}>
                                            <StyledTableRow>
                                                <StyledTableCell component='th'
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600 }}
                                                >
                                                    Lead to Meeting
                                                </StyledTableCell>

                                                {monthlyData?.map((item, index) => (
                                                    <React.Fragment key={index}>
                                                        <StyledTableCell component="th"
                                                            style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600 }}
                                                        >
                                                            {item?.leadToMeetingGoal + "%"}
                                                        </StyledTableCell>
                                                    </React.Fragment>
                                                ))}

                                            </StyledTableRow>

                                            <StyledTableRow>
                                                <StyledTableCell component="th"
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600 }}
                                                >
                                                    Meeting to Order
                                                </StyledTableCell>
                                                {monthlyData?.map((item, index) => (
                                                    <React.Fragment key={index}>
                                                        <StyledTableCell component="th"
                                                            style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600 }}
                                                        >
                                                            {item?.meetingToOrderGoal + "%"}
                                                        </StyledTableCell>
                                                    </React.Fragment>
                                                ))}
                                            </StyledTableRow>

                                            <StyledTableRow>
                                                <StyledTableCell component="th"
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600 }}
                                                >
                                                    Lead to Order
                                                </StyledTableCell>
                                                {monthlyData?.map((item, index) => (
                                                    <React.Fragment key={index}>
                                                        <StyledTableCell component="th"
                                                            style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600 }}
                                                        >
                                                            {item?.leadToOrderGoal + "%"}
                                                        </StyledTableCell>
                                                    </React.Fragment>
                                                ))}
                                            </StyledTableRow>

                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>

                            {/* Table - 3 */}
                            <Grid
                                container
                                spacing={2}
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Grid item xs={2}>
                                    <Button
                                        style={{
                                            backgroundColor: "#1C375D",
                                            color: "#FFF2EB",
                                            marginTop: "20px",
                                            fontWeight: 600
                                        }}
                                    >
                                        Table - 2
                                    </Button>
                                </Grid>
                            </Grid>
                            <div style={{ maxHeight: "500px", overflow: "auto" }}>
                                <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '10px', marginBottom: '20px' }}>
                                    <Table size="small" style={{ minWidth: '600px' }}> {/* Ensure a minimum width for horizontal scrolling */}
                                        <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                                            <StyledTableRow>
                                                <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}></StyledTableCell>
                                                {leadData[leadData?.length - 1]?.monthlyGrandTotal?.map((month, monthIndex) => (
                                                    <React.Fragment key={monthIndex}>
                                                        <StyledTableCell
                                                            style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600 }}
                                                        >
                                                            {`${month?.monthName?.slice(0, 3)}-${month?.year % 100}`}
                                                        </StyledTableCell>
                                                    </React.Fragment>
                                                ))}
                                            </StyledTableRow>
                                        </TableHead>

                                        <TableBody style={{ position: 'sticky', top: 0, background: 'white' }}>
                                            <StyledTableRow>
                                                <StyledTableCell component="th"
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600 }}
                                                >
                                                    Lead Assigned
                                                </StyledTableCell>

                                                {leadData[leadData?.length - 1]?.monthlyGrandTotal?.map((item, monthIndex) => (
                                                    <React.Fragment key={monthIndex}>
                                                        <StyledTableCell component="th"
                                                            style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600, cursor: 'pointer', textDecoration: 'underline' }}
                                                            onClick={() => dataBasedOnClick(item.countData, 'L2M')}
                                                        >
                                                            {item?.count}
                                                        </StyledTableCell>
                                                    </React.Fragment>
                                                ))}

                                            </StyledTableRow>
                                            <StyledTableRow>
                                                <StyledTableCell component="th"
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600 }}
                                                >
                                                    Meeting Done
                                                </StyledTableCell>

                                                {leadData[leadData?.length - 1]?.monthlyGrandTotal?.map((item, monthIndex) => (
                                                    <React.Fragment key={monthIndex}>
                                                        <StyledTableCell component="th"
                                                            style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600, cursor: 'pointer', textDecoration: 'underline' }}
                                                            onClick={() => dataBasedOnClick(item.leadToMeetingCountData, 'L2M')}
                                                        >
                                                            {item?.leadToMeetingCount}
                                                        </StyledTableCell>
                                                    </React.Fragment>
                                                ))}

                                            </StyledTableRow>
                                            <StyledTableRow>
                                                <StyledTableCell component="th"
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600 }}
                                                >
                                                    WON
                                                </StyledTableCell>

                                                {leadData[leadData?.length - 1]?.monthlyGrandTotal?.map((item, monthIndex) => (
                                                    <React.Fragment key={monthIndex}>
                                                        <StyledTableCell component="th"
                                                            style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600, cursor: 'pointer', textDecoration: 'underline' }}
                                                            onClick={() => { dataBasedOnClick(item.leadToOrderCountData, 'L2O'); changeView('Won') }}
                                                        >
                                                            {item?.leadToOrderCount}
                                                        </StyledTableCell>
                                                    </React.Fragment>
                                                ))}

                                            </StyledTableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>

                            {/* 2nd Table */}
                            <Grid
                                container
                                spacing={5}
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Grid item xs={5}>
                                    <>
                                        <Button
                                            style={{
                                                backgroundColor: "#1C375D",
                                                color: "#FFF2EB",
                                                marginTop: "12px",
                                                marginBottom: '5px',
                                                fontWeight: 600
                                            }}
                                        >
                                            Table - 3
                                        </Button>
                                        <h3> Monthly Conversion % Achieved: Previous Months and Current</h3>
                                    </>
                                </Grid>
                            </Grid>
                            <div style={{ maxHeight: "500px", overflow: "auto" }}>
                                <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '10px' }}>
                                    <Table size="small" style={{ minWidth: '600px' }}> {/* Ensure a minimum width for horizontal scrolling */}
                                        <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                                            <StyledTableRow>
                                                <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}></StyledTableCell>
                                                {leadData[leadData?.length - 1]?.monthlyGrandTotal?.map((month, monthIndex) => (
                                                    <React.Fragment key={monthIndex}>
                                                        <StyledTableCell component="th"
                                                            style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600 }}
                                                        >
                                                            {`${month?.monthName?.slice(0, 3)}-${month?.year % 100}`}
                                                        </StyledTableCell>
                                                    </React.Fragment>
                                                ))}
                                            </StyledTableRow>
                                        </TableHead>

                                        <TableBody style={{ position: 'sticky', top: 0, background: 'white' }}>
                                            <StyledTableRow>
                                                <StyledTableCell component="th"
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600 }}
                                                >
                                                    Lead to Meeting
                                                </StyledTableCell>
                                                {leadData[leadData?.length - 1]?.monthlyGrandTotal?.map((item, monthIndex) => (
                                                    <React.Fragment key={monthIndex}>
                                                        <StyledTableCell component="th"
                                                            style={{
                                                                position: 'sticky', left: 0, textAlign: "center", cursor: 'pointer', textDecoration: 'underline', fontWeight: 600,
                                                                background: ((item?.leadToMeetingCount / item?.count) * 100) >=
                                                                    (monthlyData?.[monthIndex]?.leadToMeetingGoal || 0)
                                                                    ? 'green'
                                                                    : 'red'
                                                            }}
                                                            onClick={() => dataBasedOnClick(item?.leadToMeetingCountData, 'L2M')}
                                                        >
                                                            {
                                                                item?.leadToMeetingCount && item?.count > 0
                                                                    ? ((item?.leadToMeetingCount / item?.count) * 100).toFixed(0) + "%"
                                                                    : "0%"
                                                            }
                                                        </StyledTableCell>
                                                    </React.Fragment>
                                                ))}
                                            </StyledTableRow>
                                            <StyledTableRow>
                                                <StyledTableCell component="th"
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600 }}
                                                >
                                                    Meeting to Order
                                                </StyledTableCell>

                                                {leadData[leadData?.length - 1]?.monthlyGrandTotal?.map((item, monthIndex) => (
                                                    <React.Fragment key={monthIndex}>
                                                        <StyledTableCell component="th"
                                                            style={{
                                                                position: 'sticky', left: 0, textAlign: "center", cursor: 'pointer', fontWeight: 600, textDecoration: 'underline',
                                                                background:
                                                                    ((item?.meetingToOrderCount / item?.leadToMeetingCount) * 100) >=
                                                                        (monthlyData?.[monthIndex]?.meetingToOrderGoal || 0)
                                                                        ? 'green'
                                                                        : 'red'
                                                            }}
                                                            onClick={() => dataBasedOnClick(item?.meetingToOrderCountData, 'M2O')}
                                                        >
                                                            {
                                                                item?.meetingToOrderCount > 0 && item?.leadToMeetingCount > 0
                                                                    ? ((item?.meetingToOrderCount / item?.leadToMeetingCount) * 100).toFixed(0) + "%"
                                                                    : "0%"
                                                            }
                                                        </StyledTableCell>
                                                    </React.Fragment>
                                                ))}

                                            </StyledTableRow>
                                            <StyledTableRow>
                                                <StyledTableCell component="th"
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600 }}
                                                >
                                                    Lead to Order
                                                </StyledTableCell>

                                                {leadData[leadData?.length - 1]?.monthlyGrandTotal?.map((item, monthIndex) => (
                                                    <React.Fragment key={monthIndex}>
                                                        <StyledTableCell component="th"
                                                            style={{
                                                                position: 'sticky', left: 0, textAlign: "center", cursor: 'pointer', fontWeight: 600, textDecoration: 'underline',
                                                                background: (
                                                                    ((item?.leadToOrderCount / ((item?.count - item?.leadInMarketing) || 1)) * 100)
                                                                    >= (monthlyData?.[monthIndex]?.leadToOrderGoal || 0)
                                                                ) ? 'green' : 'red'
                                                            }}
                                                            onClick={() => dataBasedOnClick(item?.leadToOrderCountData, 'L2O')}
                                                        >
                                                            {
                                                                (item?.leadToOrderCount && (item?.count - item?.leadInMarketing)) > 0
                                                                    ? ((item?.leadToOrderCount / (item?.count - item?.leadInMarketing)) * 100).toFixed(0) + "%"
                                                                    : "0%"
                                                            }
                                                        </StyledTableCell>
                                                    </React.Fragment>
                                                ))}

                                            </StyledTableRow>

                                            <StyledTableRow>
                                                <StyledTableCell component="th"
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 600 }}
                                                >
                                                    Delta to L2O
                                                </StyledTableCell>
                                                {monthlyData?.map((item, i) => {
                                                    const grandTotal = leadData?.[leadData.length - 1]?.monthlyGrandTotal?.[i];
                                                    const totalCount = grandTotal?.count;
                                                    const totalCountPercentage = Math.round((totalCount * item?.leadToOrderGoal) / 100).toFixed(0);
                                                    const L2M = grandTotal?.leadToOrderCount;
                                                    let percentageDiff = 0;
                                                    if (totalCount > 0) {
                                                        percentageDiff = totalCountPercentage - L2M
                                                    }

                                                    return (
                                                        <React.Fragment key={i}>
                                                            <StyledTableCell
                                                                component="th"
                                                                style={{
                                                                    position: 'sticky',
                                                                    left: 0,
                                                                    textAlign: 'center',
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {percentageDiff >= 0 ? percentageDiff : 0}
                                                            </StyledTableCell>
                                                        </React.Fragment>
                                                    );
                                                })}

                                            </StyledTableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </>
                    </div>
                    : (
                        <Typography
                            variant="body2"
                            align="center"
                            style={{ marginTop: "1rem" }}
                        >
                            No Monthly Conversion data available
                        </Typography>
                    )
            }

            {/* Modal */}
            <Modal
                title='Lead Data'
                centered
                visible={openModal}
                onCancel={() => setOpenModal(false)}
                width={1000}
                maskClosable={true}
                footer={null}
                zIndex={2000}
            >
                <div className={classes.csv}>
                    <CSVLink
                        headers={headers}
                        filename='leadData.csv'
                        data={csvData}
                        ref={csvButtonRef}
                    />
                    <Button
                        onClick={() => csvDownloadHandler(clickData)}
                        style={{ backgroundColor: "#355025", color: "#FFF2EB" }}
                        variant="contained"
                        color="secondary"
                    >
                        Download CSV
                    </Button>
                    <>
                        {wonLeadView === '' &&
                            <>
                                <Button variant="contained" color="primary" style={{ marginLeft: 10 }} className={classes.tableViewButton} onClick={() => projectTableView('table')}>
                                    Table View
                                </Button>
                                <Button variant="contained" color="secondary" style={{ marginLeft: 10 }} className={classes.boardViewButton} onClick={() => projectBoardView('board')}>
                                    Board View
                                </Button>
                            </>
                        }
                    </>
                </div>

                {leadData && (
                    projectViewType === 'table' ?
                        <TableContainer component={Paper} className={classes.table}>
                            <Table
                                style={{ width: 500 }}
                                className={classes.table}
                                stickyHeader
                                aria-label="sticky table"
                            >
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell>Sl. No.</StyledTableCell>
                                        <StyledTableCell>Project No.</StyledTableCell>
                                        <StyledTableCell>Lead No.</StyledTableCell>
                                        <StyledTableCell>Client Name</StyledTableCell>
                                        <StyledTableCell>Assign To</StyledTableCell>
                                        <StyledTableCell>City Name</StyledTableCell>
                                        <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                                        <StyledTableCell>Current Stage</StyledTableCell>
                                        <StyledTableCell>Lead Assigned Date</StyledTableCell>
                                        <StyledTableCell>Created At Date</StyledTableCell>
                                        <StyledTableCell>Sales Executive</StyledTableCell>
                                        <StyledTableCell>ASM</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {clickData?.map((data, i) => {
                                        return (
                                            <StyledTableRow key={i}>
                                                <StyledTableCell>{i + 1}</StyledTableCell>
                                                <StyledTableCell
                                                    component="th"
                                                    style={{ textAlign: "center" }}
                                                >
                                                    {
                                                        data?.erpProjectNo ? <Link to={`/project-logs/${data?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data?.erpProjectNo}</Link> : 'NA'
                                                    }
                                                </StyledTableCell>
                                                <StyledTableCell
                                                    component="th"
                                                    style={{ textAlign: "center" }} >
                                                    {
                                                        data?.lead_no ? <Link to={`/project-logs/${data?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data?.lead_no}</Link> : 'NA'
                                                    }
                                                </StyledTableCell>
                                                <StyledTableCell
                                                    component="th"
                                                    style={{ textAlign: "center" }}
                                                >
                                                    {data?.customerName}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}> {data?.assignToName} </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}> {data?.cityName} </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}> {data?.experienceCenterName} </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.currentStage ? data?.currentStage : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.leadAssignedDate ? moment(data?.leadAssignedDate).format("DD-MM-YYYY") : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.createdAt ? moment(data?.createdAt).format("DD-MM-YYYY") : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.salesUserName ? data?.salesUserName : 'NA'}
                                                </StyledTableCell>
                                                <StyledTableCell component="th" style={{ textAlign: "center" }}>
                                                    {data?.assistantSalesManagerName ? data?.assistantSalesManagerName : 'NA'}
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        :
                        <TableContainer component={Paper}>
                            <Table className="table table-responsive table-bordered" stickyHeader aria-label="sticky table">
                                {boardViewData.length > 0 ?

                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ display: "inline-flex" }}>
                                                {boardViewData.map((row, i) => {
                                                    return (
                                                        <Table key={i + 1} className="table-responsive" style={{ width: "200px", borderRight: "1px solid #000" }}>
                                                            <TableHead style={{ height: "100px" }}>
                                                                <StyledTableRow>
                                                                    <StyledTableCell>{row?.currentStage} - ({row?.projects?.length})</StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableHead>
                                                            <TableBody style={{ display: "block", height: "auto", overflow: "auto" }}>
                                                                {
                                                                    row.projects?.map((row1, i) => {
                                                                        return (
                                                                            <StyledTableRow key={i + 1} style={{ height: "100px", display: "flex", flexWrap: "nowrap", alignContent: "center", justifyContent: "space-evenly", flexDirection: "row" }}>
                                                                                <StyledTableCell style={{ border: "none", textAlign: "center" }}>
                                                                                    <Link
                                                                                        to={`/project-logs/${row1._id}`}
                                                                                        style={{ color: "#000" }}
                                                                                        target="_blank"
                                                                                    >
                                                                                        {row1?.customerName} <br />
                                                                                        (₹ {row1.grandTotal ? commaSeparateAmount(row1?.grandTotal) : `0`})
                                                                                    </Link>
                                                                                </StyledTableCell>
                                                                            </StyledTableRow>
                                                                        )
                                                                    })
                                                                }
                                                            </TableBody>
                                                            <TableFooter style={{ height: "80px" }}>
                                                                <StyledTableRow>
                                                                    <StyledTableCell style={{ color: 'black' }}>
                                                                        <b>Total : ₹ {commaSeparateAmount(row.finalAmount)} </b>
                                                                    </StyledTableCell>
                                                                </StyledTableRow>
                                                            </TableFooter>
                                                        </Table>
                                                    );
                                                })}
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                    :
                                    <StyledTableCell style={{ textAlign: 'center' }}>No Records Found</StyledTableCell>
                                }
                            </Table>
                        </TableContainer>
                )}
            </Modal>

            {/* {userDetails?.roles?.find(role => role.name === ROLENAME.AssistantSalesManager) && <>
                <ASMDashboard userdata={userDetails} />
            </>
            } */}

            <Modal
                title="Performance Vs Target Data"
                centered
                visible={dataBasedOnClickAcvModal}
                onCancel={() => setDataBasedOnClickAcvModal(false)}
                width={1000}
                maskClosable={true}
                footer={null}
                zIndex={2000}
            >
                {dataBasedOnClickAcv && (
                    <TableContainer component={Paper} className={classes.table}>
                        <Table
                            style={{ width: 900 }}
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Sales Won User</StyledTableCell>
                                    <StyledTableCell>Lead Status</StyledTableCell>
                                    <StyledTableCell>Lead Won Date</StyledTableCell>
                                    <StyledTableCell>Won Amount</StyledTableCell>
                                    <StyledTableCell>Design Kick Off Meeting Date</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {dataBasedOnClickAcv &&
                                    dataBasedOnClickAcv.map((item, i) => {
                                        return (
                                            <>
                                                <StyledTableRow key={i}>
                                                    <StyledTableCell>{i + 1}</StyledTableCell>
                                                    <StyledTableCell
                                                        component="th"
                                                        style={{ textAlign: "center" }}
                                                    >
                                                        {item?.lead_no ? (
                                                            <Link
                                                                to={`/project-logs/${item?._id}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{
                                                                    color: "#000",
                                                                    textDecoration: "underline",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                {item?.lead_no}
                                                            </Link>
                                                        ) : (
                                                            "NA"
                                                        )}
                                                    </StyledTableCell>
                                                    <StyledTableCell
                                                        component="th"
                                                        style={{ textAlign: "center" }}
                                                    >
                                                        {item?.salesWonUser.name}
                                                    </StyledTableCell>
                                                    <StyledTableCell component="th">
                                                        {item?.leadStatus}
                                                    </StyledTableCell>
                                                    <StyledTableCell component="th">
                                                        {item?.leadWonDate ? moment(item?.leadWonDate).format('DD-MM-YYYY') : '-'}
                                                    </StyledTableCell>
                                                    <StyledTableCell component="th">
                                                        {item?.staticSalesWonAmount}
                                                    </StyledTableCell>
                                                    <StyledTableCell component="th">
                                                        {item?.dateOfDesignKickOffMeeting ? moment(item?.dateOfDesignKickOffMeeting).format('DD-MM-YYYY') : '-'}
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            </>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Modal>
        </div>
    );
};

export default connect(null, { setUserDetails, setLoading, setSnackInfo })(LeadFromMeetingToOrder);